<!-- svelte-ignore a11y-missing-attribute -->
<div class="modal is-active">
  <div class="modal-background" />
  <div class="modal-content">
    <div class="card">
      <section class="card-content">
        <div class="block">
          It's free to make small occasional offers, but we ask for a fee for large or high value donations to help support our running costs. For more information see our <a href="https://www.agoodthing.org.uk/business-pricing">business pricing</a>.</div>
        <div class="columns">
          <div class="column">
            <a on:click={() => select('small')}>
            <div class="box box-hoverable" class:box-hover-active={smallHover} on:mouseover={() => smallHover=true} on:mouseout={() => smallHover=false} >
              <div class="title">Free</div>
              <div class="block">Suitable for occasional small and low-cost donations.</div>
              <hr/>
              <div class="block">
                <p><strong>Monthly limits</strong></p>
                <ul>
                  <li>Up to 3 offers</li>
                  <li>Up to 5m<sup>3</sup> size</li>
                  <li>Up to £1500 value</li>
                </ul>
              </div>
              <hr/>
              <div class="block">
                <div class="subtitle">FREE</div>
              </div>
            </div>
          </a>
          </div>
          
          <div class="column">
            <a on:click={() => select('large')}>
              <div class="box box-hoverable" class:box-hover-active={largeHover} on:mouseover={() => largeHover=true} on:mouseout={() => largeHover=false} >
              <div class="title">Premium</div>
              <div class="block">Required for large or high-value donations.
              </div>
              <hr/>
              <div class="block">
                <p><strong>Unlimited</strong></p>
                <ul>
                  <li>Unlimited offers</li>
                  <li>Unlimited size</li>
                  <li>Unlimited value</li>
                </ul>
              </div>
              <hr/>
              <div class="block">
                <div class="subtitle">£29 (one month)</div>
              </div>
            </div>
            </a>
          </div>
        </div>
        <div class="block">
          Unsure? No problem. Contact us at <a href="mailto:hello@agoodthing.org.uk">hello@agoodthing.org.uk</a> and we would be happy to discuss your offer.
        </div>
      </section>
      <footer class="card-footer">
        <a href="#" class="card-footer-item" on:click={close}>Cancel</a>
      </footer>
    </div>
  </div>
</div>

<script lang="ts">
  import { url, goto } from '@sveltech/routify';
  import { uiState } from '../../../../lib/uiState';
  import BoxImage from './BoxImage.svelte';
  import DeskImage from './DeskImage.svelte';
  import ChairImage from './ChairImage.svelte';

  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  function close() {
    $uiState.activeModal = undefined;
  }

  let smallHover = false;
  let largeHover = false;

  function select(size: string) {
    close();
    $goto('./offers/create', { size });
  }
</script>

<style>
  .box-hoverable {
    -cursor: pointer;
    border-color:white;
    border-width:1px;
    border-style:solid;
  }

  .box-hover-active {
    border-color:lightgrey;
    border-width:1px;
    border-style:solid;
  }
</style>